import { TransactionDirectionType } from "@common/categories";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { SelectedTransaction } from "./transactionsBulkActionsContext";

export function mapTransactionToSelected(
    transaction: TransactionListItem,
): SelectedTransaction {
    return {
        ...transaction,
        transactionDirection:
            transaction.amount > 0
                ? TransactionDirectionType.incoming
                : TransactionDirectionType.outgoing,
    };
}

export const TOAST_MESSAGE_KEY = "transactions-bulk-actions";
